import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f3d304b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M0 7.70095L0.692041 7.04476L5.48097 11.2667L5.48097 0L6.53287 0L6.53287 11.2667L11.2803 7.06952L12 7.71333L5.99308 13L0 7.70095Z" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M8.20095 12.5L7.54476 11.808L11.7667 7.01903L0.5 7.01903L0.5 5.96713L11.7667 5.96713L7.56952 1.21973L8.21333 0.500001L13.5 6.50692L8.20095 12.5Z",
  fill: "black"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.79905 0.5L6.45524 1.19204L2.23333 5.98097L13.5 5.98097V7.03287L2.23333 7.03287L6.43048 11.7803L5.78667 12.5L0.499999 6.49308L5.79905 0.5Z",
  fill: "black"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 5.29905L11.308 5.95524L6.51903 1.73333L6.51903 13H5.46713L5.46713 1.73333L0.719726 5.93048L9.53674e-07 5.28667L6.00692 -9.53674e-07L12 5.29905Z",
  fill: "black"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7.19646 2.9931C8.33274 1.25517 10.0372 0 12.5938 0C17.1389 0 20.169 3.57241 20.169 8.2069V22.9793H12.9726V10.4276C12.9726 8.4 11.8363 7.14483 10.0372 7.14483C8.33274 7.14483 7.19646 8.2069 7.10177 10.1379V23.0759H0V0.482759H7.19646V2.9931Z" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M32.6681 25.393C33.8043 23.7516 35.5088 22.3999 38.0654 22.3999C41.0955 22.3999 43.4628 23.7516 44.6937 26.1654C45.83 24.1378 47.8185 22.3999 51.038 22.3999C55.299 22.3999 58.6132 25.9723 58.6132 30.6068V45.3792H51.4167V32.8275C51.4167 30.7999 50.2805 29.5447 48.576 29.5447C46.8716 29.5447 45.5459 30.7999 45.5459 32.8275V45.3792H38.3495V32.8275C38.3495 30.7999 37.2132 29.5447 35.5088 29.5447C33.7097 29.5447 32.5734 30.7034 32.4787 32.5378V45.4758H25.2822V22.8827H32.4787V25.393H32.6681Z" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M71.2071 2.9931C72.3434 1.35172 74.0478 0 76.6045 0C79.6346 0 82.0018 1.35172 83.2328 3.76552C84.3691 1.73793 86.3576 0 89.577 0C93.8381 0 97.1523 3.57241 97.1523 8.2069V22.9793H89.9558V10.4276C89.9558 8.4 88.8195 7.14483 87.1151 7.14483C85.316 7.14483 84.085 8.4 84.085 10.4276V22.9793H76.8885V10.4276C76.8885 8.4 75.7523 7.14483 74.0478 7.14483C72.2487 7.14483 71.1124 8.30345 71.0177 10.1379V23.0759H63.8213V0.482759H71.0177V2.9931H71.2071Z" }, null, -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"40"},
  "stroke-linecap": "round",
  x1: "17.8",
  y1: "50",
  x2: "483",
  y2: "50"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"40"},
  "stroke-linecap": "round",
  x1: "17.8",
  y1: "250",
  x2: "483",
  y2: "250"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"40"},
  "stroke-linecap": "round",
  x1: "17.8",
  y1: "450",
  x2: "483",
  y2: "450"
}, null, -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"40"},
  "stroke-linecap": "round",
  x1: "18",
  y1: "50",
  x2: "483",
  y2: "450"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"40"},
  "stroke-linecap": "round",
  x1: "18",
  y1: "450",
  x2: "483",
  y2: "50"
}, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  style: {"stroke-width":"4","stroke-miterlimit":"10"},
  d: "M47.45,19.4c2.39,2.39,6.25,2.39,8.64,0\n\t\t\tl7.73,7.73L27.19,63.77l-7.73-7.73c2.39-2.39,2.39-6.25,0-8.64c-2.39-2.39-6.25-2.39-8.64,0l-7.73-7.73L39.71,3.03l7.73,7.73\n\t\t\tC45.06,13.15,45.06,17.02,47.45,19.4z"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10"},
  x1: "29.31",
  y1: "16.33",
  x2: "29.49",
  y2: "16.51"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10","stroke-dasharray":"0.5463, 5.4627"},
  x1: "33.35",
  y1: "20.37",
  x2: "48.42",
  y2: "35.44"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  style: {"fill":"none","stroke":"#231f20","stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10"},
  x1: "50.35",
  y1: "37.37",
  x2: "50.53",
  y2: "37.54"
}, null, -1))
const _hoisted_24 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { transform: "translate(0 0)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M42.25,12.48c3.23,0,6.27,1.26,8.55,3.54s3.54,5.32,3.54,8.55s-1.26,6.27-3.54,8.55\n\t\t\ts-5.32,3.54-8.55,3.54s-6.27-1.26-8.55-3.54s-3.54-5.32-3.54-8.55s1.26-6.27,3.54-8.55S39.02,12.48,42.25,12.48 M42.25,8.48\n\t\t\tc-4.12,0-8.24,1.57-11.38,4.71c-6.28,6.28-6.28,16.47,0,22.76c3.14,3.14,7.26,4.71,11.38,4.71s8.24-1.57,11.38-4.71\n\t\t\tc6.28-6.28,6.28-16.47,0-22.76C50.49,10.05,46.37,8.48,42.25,8.48L42.25,8.48z" }),
  /*#__PURE__*/_createElementVNode("line", {
    style: {"stroke-width":"4","stroke-miterlimit":"10"},
    x1: "27.23",
    y1: "39.59",
    x2: "31.16",
    y2: "35.67"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    style: {"stroke-width":"8","stroke-miterlimit":"10"},
    x1: "10.69",
    y1: "56.14",
    x2: "27.23",
    y2: "39.59"
  })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<g transform=\"translate(0 2)\" data-v-1f3d304b><rect x=\"8.51\" y=\"19.04\" style=\"stroke-width:4;stroke-miterlimit:10;\" width=\"49.83\" height=\"28.72\" data-v-1f3d304b></rect><polyline style=\"stroke-width:2;stroke-miterlimit:10;\" points=\"8.51,19.04 33.43,39.67 58.34,19.04 \t\t\n\t\t\t\" data-v-1f3d304b></polyline><line style=\"stroke-width:2;stroke-miterlimit:10;\" x1=\"8.51\" y1=\"47.76\" x2=\"25.44\" y2=\"33.06\" data-v-1f3d304b></line><line style=\"stroke-width:2;stroke-miterlimit:10;\" x1=\"58.34\" y1=\"47.76\" x2=\"41.41\" y2=\"33.06\" data-v-1f3d304b></line></g>", 1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M161 84.7182L161.002 84.7174C170.82 82.0352 181.056 86.7708 185.388 95.8475L185.849 96.9537L213.818 164.08L213.819 164.083C217.383 172.625 214.924 182.475 207.736 188.351C207.736 188.351 207.736 188.351 207.736 188.351L173.264 216.53L169.03 219.991L171.368 224.934C195.345 275.622 236.378 316.655 287.066 340.631L292.003 342.967L295.464 338.743L323.713 304.27L323.726 304.255L323.738 304.24C329.529 297.093 339.428 294.61 347.987 298.181L347.99 298.182L415.116 326.151L415.124 326.154L415.131 326.157C424.87 330.189 430.064 340.818 427.283 350.997L427.282 351L410.506 412.513C410.505 412.517 410.503 412.521 410.502 412.525C407.972 421.676 399.668 428.008 390.256 428.008C221.128 428.008 83.9923 290.872 83.9923 121.744C83.9923 112.331 90.3252 104.026 99.4774 101.497C99.4805 101.496 99.4837 101.495 99.4868 101.494L161 84.7182Z",
  stroke: "black",
  "stroke-width": "13.9846"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<path d=\"M36.376 144.702H463.999V385.236H36.376V144.702Z\" stroke=\"black\" stroke-width=\"14\" data-v-1f3d304b></path><path d=\"M37 384L179 257\" stroke=\"black\" stroke-width=\"14\" data-v-1f3d304b></path><path d=\"M463 383L325 254\" stroke=\"black\" stroke-width=\"14\" data-v-1f3d304b></path><path d=\"M41.0002 145.5L254.482 313.623\" stroke=\"black\" stroke-width=\"14\" data-v-1f3d304b></path><path d=\"M245.543 313.602L462 148\" stroke=\"black\" stroke-width=\"14\" data-v-1f3d304b></path>", 5)
const _hoisted_36 = [
  _hoisted_31
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  r: "100",
  cy: "100",
  cx: "100"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { class: "mouse" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "1.15385",
    y: "1.15385",
    width: "23.8462",
    height: "40",
    rx: "11.9231",
    stroke: "white",
    "stroke-width": "2.30769"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "13.4615",
    y1: "11.1538",
    x2: "13.4615",
    y2: "17.3077",
    stroke: "white",
    "stroke-width": "2.30769",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.38477 53.0769L13.0771 60L20.7694 53.0769",
  stroke: "white",
  "stroke-width": "2.30769",
  class: "arrow"
}, null, -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19.9008 13.2695C19.9008 13.4695 20.0008 13.4695 20.1008 13.4695C21.4008 13.4695 22.7008 13.4695 24.0008 13.4695C24.1008 13.4695 24.2008 13.4695 24.3008 13.4695C24.1008 15.1695 24.0008 16.7695 23.8008 18.4695C22.5008 18.4695 21.2008 18.4695 19.9008 18.4695C19.9008 18.5695 19.9008 18.6695 19.9008 18.7695C19.9008 23.3695 20.0008 27.9695 20.0008 32.6695C20.0008 32.7695 20.0008 32.8695 20.0008 32.9695C18.2008 32.9695 16.4008 32.9695 14.6008 32.9695C14.6008 28.2695 14.5008 23.4695 14.5008 18.7695C14.5008 18.6695 14.5008 18.6695 14.5008 18.5695C13.3008 18.5695 12.1008 18.5695 10.9008 18.5695C10.9008 18.4695 10.9008 18.3695 10.9008 18.3695C10.9008 16.8695 10.9008 15.3695 10.9008 13.8695C10.9008 13.6695 11.0008 13.5695 11.2008 13.5695C12.2008 13.5695 13.3008 13.5695 14.3008 13.5695C14.5008 13.5695 14.6008 13.4695 14.6008 13.2695C14.6008 11.9695 14.6008 10.5695 14.6008 9.26953C14.6008 8.26953 14.8008 7.36953 15.3008 6.46953C15.8008 5.46953 16.6008 4.86953 17.6008 4.46953C18.2008 4.26953 18.8008 4.16953 19.3008 4.06953C19.4008 4.06953 19.5008 4.06953 19.5008 3.96953C21.1008 3.96953 22.7008 3.96953 24.3008 3.96953C24.3008 4.36953 24.3008 4.76953 24.3008 5.06953C24.3008 6.26953 24.3008 7.46953 24.3008 8.66953C24.3008 8.86953 24.2008 8.96953 24.0008 8.96953C23.1008 8.96953 22.2008 8.96953 21.3008 8.96953C21.1008 8.96953 20.9008 9.06953 20.7008 9.06953C20.2008 9.26953 19.9008 9.56953 19.9008 10.1695C19.9008 11.1695 19.9008 12.1695 19.9008 13.2695ZM37.1008 34.7695V2.56953C36.9008 1.86953 36.7008 1.26953 36.0008 0.869531C35.6008 0.569531 35.1008 0.469531 34.7008 0.269531H2.70078C2.20078 0.469531 1.80078 0.569531 1.40078 0.869531C0.800781 1.26953 0.500781 1.86953 0.300781 2.56953V34.7695C0.500781 35.4695 0.800781 36.1695 1.40078 36.5695C1.80078 36.7695 2.20078 36.9695 2.60078 37.0695H34.8008C35.2008 36.8695 35.6008 36.7695 36.0008 36.4695C36.6008 36.0695 36.9008 35.4695 37.1008 34.7695Z",
  fill: "white"
}, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.89922 9.46914C5.89922 10.0691 6.09922 10.5691 6.39922 11.0691C7.39922 12.4691 9.59922 12.5691 10.8992 11.6691C12.3992 10.5691 12.3992 8.26914 10.8992 7.16914C10.3992 6.66914 9.49922 6.56914 8.59922 6.66914C7.09922 6.86914 5.89922 8.06914 5.89922 9.46914ZM6.19922 14.5691V14.8691C6.19922 20.1691 6.19922 25.4691 6.19922 30.7691C6.19922 31.0691 6.29922 31.0691 6.49922 31.0691C8.09922 31.0691 9.79922 31.0691 11.3992 31.0691C11.6992 31.0691 11.6992 30.9691 11.6992 30.7691C11.6992 25.4691 11.6992 20.1691 11.6992 14.9691C11.6992 14.8691 11.6992 14.7691 11.6992 14.6691L6.19922 14.5691ZM14.8992 30.9691C14.9992 31.0691 14.9992 31.0691 14.8992 30.9691C16.6992 30.9691 18.4992 30.9691 20.1992 30.9691C20.3992 30.9691 20.3992 30.8691 20.3992 30.7691C20.3992 30.4691 20.3992 30.1691 20.3992 29.8691C20.3992 27.0691 20.3992 24.1691 20.3992 21.3691C20.3992 19.7691 21.5992 18.5691 23.1992 18.4691C24.4992 18.3691 25.4992 18.9691 25.8992 20.2691C26.0992 20.9691 26.1992 21.6691 26.1992 22.3691C26.1992 25.1691 26.1992 27.9691 26.1992 30.6691C26.1992 30.9691 26.2992 31.0691 26.5992 31.0691C28.1992 31.0691 29.7992 31.0691 31.3992 31.0691C31.6992 31.0691 31.6992 30.9691 31.6992 30.7691C31.6992 27.7691 31.6992 24.7691 31.6992 21.6691C31.6992 20.5691 31.5992 19.3691 31.1992 18.2691C30.6992 16.8691 29.8992 15.7691 28.6992 14.9691C27.6992 14.3691 26.6992 14.1691 25.4992 14.1691C23.3992 14.1691 21.7992 14.8691 20.5992 16.5691C20.5992 16.6691 20.4992 16.6691 20.3992 16.7691C20.3992 16.0691 20.3992 15.4691 20.3992 14.7691C20.3992 14.5691 20.2992 14.4691 20.0992 14.4691C18.4992 14.4691 16.7992 14.4691 15.1992 14.4691C15.0992 14.4691 14.9992 14.4691 14.8992 14.4691V30.9691ZM0.699219 34.6691V2.66914C0.899219 1.96914 1.19922 1.36914 1.79922 0.969141C2.19922 0.769141 2.59922 0.569141 3.09922 0.369141H34.8992C35.2992 0.569141 35.7992 0.669141 36.1992 0.969141C36.7992 1.36914 37.0992 1.96914 37.2992 2.66914V34.6691C37.0992 35.3691 36.7992 35.9691 36.1992 36.3691C35.7992 36.5691 35.3992 36.7691 34.9992 36.8691H2.99922C2.59922 36.6691 2.19922 36.5691 1.79922 36.3691C1.29922 36.0691 0.999219 35.4691 0.699219 34.6691Z",
  fill: "white"
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 0C1.34314 0 0 1.34375 0 3V33C0 34.6562 1.34314 36 3 36H33C34.6569 36 36 34.6562 36 33V3C36 1.34375 34.6569 0 33 0H3ZM10.3125 17.9941C10.3125 13.7695 13.7478 10.3633 18.0067 10.3633C22.2656 10.3633 25.7009 13.7695 25.7009 17.9941C25.7009 22.2168 22.2656 25.623 18.0067 25.623C13.7478 25.623 10.3125 22.2168 10.3125 17.9941ZM13.0045 17.9941C13.0045 20.7285 15.2545 22.9531 18.0067 22.9531C20.7589 22.9531 23.0089 20.7285 23.0089 17.9941C23.0089 15.2578 20.7656 13.0332 18.0067 13.0332C15.2478 13.0332 13.0045 15.2578 13.0045 17.9941ZM26.0156 11.8301C27.0067 11.8301 27.8103 11.041 27.8103 10.0508C27.8103 9.06836 27.0067 8.27148 26.0156 8.27148C25.0245 8.27148 24.2209 9.06836 24.2209 10.0508C24.2209 11.0332 25.0178 11.8301 26.0156 11.8301ZM30.4822 5.62109C32.2433 7.36133 32.7924 9.47266 32.9062 11.8574C33.0469 14.3145 33.0469 21.6719 32.9062 24.1289C32.7858 26.5137 32.2366 28.625 30.4822 30.3652C28.7277 32.1113 26.5983 32.6562 24.1942 32.7695C21.7166 32.9082 14.2902 32.9082 11.8125 32.7695C9.40845 32.6484 7.28577 32.1055 5.52454 30.3652C3.76343 28.625 3.21423 26.5137 3.10046 24.1289C2.95984 21.6719 2.95984 14.3086 3.10046 11.8516C3.22095 9.4668 3.76343 7.35547 5.52454 5.61523C7.28577 3.875 9.41516 3.33008 11.8125 3.21875C14.2902 3.07812 21.7166 3.07812 24.1942 3.21875C26.5983 3.33789 28.7277 3.88281 30.4822 5.62109ZM26.8527 29.5938C28.1719 29.0703 29.183 28.0664 29.7053 26.7656C30.3773 25.0898 30.34 21.4277 30.3157 19.0547L30.308 17.9941L30.3157 16.9316C30.34 14.5586 30.3773 10.9004 29.7053 9.2207C29.1764 7.91211 28.1652 6.91016 26.8527 6.39258C24.8839 5.62109 20.1897 5.79492 18.0067 5.79492C15.8236 5.79492 11.1361 5.61523 9.16077 6.39258C7.84155 6.91602 6.83032 7.91992 6.30798 9.2207C5.63965 10.9004 5.67529 14.5801 5.69824 16.9551L5.70532 17.9941L5.69763 19.0547C5.67334 21.4277 5.63599 25.0859 6.30798 26.7656C6.83704 28.0742 7.84827 29.0762 9.16077 29.5938C10.8538 30.2578 14.5621 30.2207 16.9561 30.1992L18.0067 30.1914C20.1897 30.1914 24.8772 30.3711 26.8527 29.5938Z",
  fill: "white"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M34.9998 14.8695C34.1998 15.4695 33.3998 16.0695 32.4998 16.4695C31.8998 16.7695 31.6998 17.1695 31.5998 17.7695C30.0998 25.0695 23.5998 30.6695 16.1998 30.8695C11.9998 30.9695 8.2998 29.7695 4.9998 27.1695C4.6998 26.9695 4.3998 26.6695 4.0998 26.2695C6.9998 26.9695 9.7998 26.7695 12.5998 25.4695C10.0998 24.6695 8.5998 23.0695 8.0998 20.4695C8.89981 20.5695 9.5998 20.6695 10.2998 20.7695C7.9998 19.1695 6.7998 17.1695 7.1998 14.2695C7.9998 14.6695 8.69981 14.9695 9.39981 15.3695C9.39981 15.2695 9.4998 15.2695 9.4998 15.1695C8.2998 13.7695 7.7998 12.1695 8.0998 10.3695C8.2998 9.26953 8.6998 8.36953 9.4998 7.46953C10.6998 9.56953 12.0998 11.3695 13.8998 12.7695C15.6998 14.1695 17.6998 15.2695 19.9998 15.8695C20.1998 15.1695 20.1998 14.3695 20.4998 13.7695C21.2998 11.6695 22.8998 10.3695 25.0998 9.96953C27.2998 9.66953 29.1998 10.4695 30.5998 12.1695C30.8998 12.5695 31.1998 12.7695 31.6998 12.6695C32.6998 12.5695 33.6998 12.3695 34.6998 12.2695C34.0998 13.4695 32.9998 14.0695 31.9998 14.7695C32.9998 14.7695 33.8998 14.6695 34.8998 14.6695C34.8998 14.7695 34.9998 14.8695 34.9998 14.8695ZM37.8998 34.9695V2.56953C37.6998 1.86953 37.4998 1.26953 36.7998 0.869531C36.3998 0.569531 35.8998 0.469531 35.4998 0.269531H3.1998C2.7998 0.469531 2.2998 0.569531 1.8998 0.869531C1.2998 1.26953 0.999805 1.86953 0.799805 2.56953V34.9695C0.999805 35.6695 1.2998 36.3695 1.8998 36.7695C2.2998 36.9695 2.6998 37.1695 3.0998 37.2695H35.4998C35.8998 37.0695 36.2998 36.9695 36.6998 36.6695C37.4998 36.2695 37.7998 35.6695 37.8998 34.9695Z",
  fill: "white"
}, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z",
  transform: "rotate(210 25 25)"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "1.2s",
    repeatCount: "indefinite"
  })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.486328 1.43408L8.15653 8.33727L15.8267 1.43408",
  stroke: "white",
  "stroke-width": "1.4",
  style: {"mix-blend-mode":"exclusion"}
}, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "6.5",
  "stroke-width": "1.25"
}, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "5.15",
  r: "1"
}, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "7.25",
  y: "7",
  width: "1.5",
  height: "5",
  rx: "0.75"
}, null, -1))
const _hoisted_57 = [
  _hoisted_54,
  _hoisted_55,
  _hoisted_56
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'arrow-down')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 0,
          width: "12",
          height: "13",
          viewBox: "0 0 12 13",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_2, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'arrow-right')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 1,
          width: "14",
          height: "13",
          viewBox: "0 0 14 13",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_4, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'arrow-left')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 2,
          width: "14",
          height: "13",
          viewBox: "0 0 14 13",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_6, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'arrow-top')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 3,
          width: "12",
          height: "13",
          viewBox: "0 0 12 13",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_8, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'logo')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 4,
          width: "98",
          height: "46",
          viewBox: "0 0 98 46",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_12, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'menu')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 5,
          width: "500",
          height: "500",
          viewBox: "0 0 500 500",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_16, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'close')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 6,
          width: "500",
          height: "500",
          viewBox: "0 0 500 500",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_19, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'tickets')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 7,
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          x: "0px",
          y: "0px",
          viewBox: "0 0 66.8 66.8",
          style: {"enable-background":"new 0 0 66.8 66.8"},
          "xml:space": "preserve",
          class: "line"
        }, _ctx.$attrs), _hoisted_24, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'search')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 8,
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          x: "0px",
          y: "0px",
          viewBox: "0 0 66.8 66.8",
          style: {"enable-background":"new 0 0 66.8 66.8"},
          "xml:space": "preserve"
        }, _ctx.$attrs), _hoisted_26, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'mail')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 9,
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          x: "0px",
          y: "0px",
          viewBox: "0 0 66.8 66.8",
          style: {"enable-background":"new 0 0 66.8 66.8"},
          "xml:space": "preserve"
        }, _ctx.$attrs, { class: "line" }), _hoisted_28, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'contact-phone')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 10,
          width: "512",
          height: "512",
          viewBox: "0 0 512 512",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_30, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'contact-mail')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 11,
          width: "500",
          height: "500",
          viewBox: "0 0 500 500",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_36, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'sun')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 12,
          width: "200",
          height: "200",
          viewBox: "0 0 200 200",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_38, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'scroll-indicator')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 13,
          width: "27",
          height: "72",
          viewBox: "0 0 27 72",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "line" }), _hoisted_41, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'facebook')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 14,
          width: "38",
          height: "38",
          viewBox: "0 0 38 38",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_43, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'linkedin')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 15,
          width: "38",
          height: "37",
          viewBox: "0 0 38 37",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_45, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'instagram')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 16,
          width: "36",
          height: "36",
          viewBox: "0 0 36 36",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_47, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'twitter')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 17,
          width: "38",
          height: "38",
          viewBox: "0 0 38 38",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs), _hoisted_49, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'loading')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 18,
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          x: "0px",
          y: "0px",
          width: "40px",
          height: "40px",
          viewBox: "0 0 50 50",
          "xml:space": "preserve"
        }, _ctx.$attrs), _hoisted_51, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'chevron-down')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 19,
          width: "17",
          height: "10",
          viewBox: "0 0 17 10",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          class: "line"
        }, _ctx.$attrs), _hoisted_53, 16))
      : _createCommentVNode("", true),
    (_ctx.type === 'info')
      ? (_openBlock(), _createElementBlock("svg", _mergeProps({
          key: 20,
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _ctx.$attrs, { class: "icon--info" }), _hoisted_57, 16))
      : _createCommentVNode("", true)
  ], 64))
}